import { validate } from './validate';

const findFirstTranslationFor = (translations: unknown, attr: string) => {
  // @ts-ignore @TODO Epic WT-21600
  const foundTranslation = Object.values(translations)?.find((translation) => {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return validate.isNonEmptyString(translation[attr]);
  });
  return foundTranslation && foundTranslation[attr] ? foundTranslation[attr] : '';
};

const toStartCase = (word: string): string => {
  return word.charAt(0).toUpperCase() + word.slice(1);
};

const toTitlecase = (phrase: string | null): string | null => {
  if (phrase === null) {
    return null;
  }
  const eachWord = /\w\S*/g;
  const titleizedPhrase = phrase?.replace(eachWord, toStartCase);
  return titleizedPhrase;
};

const searchIn = (text: string, search: string): boolean => {
  if (!text) return false;
  if (!search) return true;

  const parsedText = text.trim().toLowerCase();
  const parsedSearchText = search.trim().toLowerCase();
  const searchTextParts = parsedSearchText.split(' ');

  return searchTextParts.every((textPart) => parsedText.includes(textPart));
};

export const text = {
  findFirstTranslationFor,
  toTitlecase,
  searchIn,
  toStartCase,
};
